export const getCookie = (key: string): any => {
    const b = document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`);

    return b ? b.pop() : '';
};

export const deleteCookie = (name: string): void => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};
